import ProductLicenseDetails from './ProductLicenseDetails'

export default ProductLicenseDetails
